import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-space-y-4"
}
const _hoisted_2 = { class: "tw-text-primary tw-text-xs tw-font-medium" }
const _hoisted_3 = { class: "tw-grid tw-grid-cols-2 tw-gap-4 sm:tw-grid-cols-3 md:tw-grid-cols-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]

import { BrandKitAsset } from '@/studio/brandKit/store/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandKitImageGrid',
  props: {
    title: {},
    images: {},
    defaultAlt: {},
    imageClass: {},
    overlayClass: {}
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;





function handleImageSelect(imageUrl: string) {
  emit('select', imageUrl);
}

function handleImageError(event: Event) {
  const img = event.target as HTMLImageElement;
  img.style.display = 'none';
}

return (_ctx: any,_cache: any) => {
  return (_ctx.images.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
            return (_openBlock(), _createElementBlock("button", {
              key: image.url,
              class: "hover:tw-border-primary focus:tw-ring-primary tw-group tw-relative tw-aspect-square tw-overflow-hidden tw-rounded-lg tw-bg-muted tw-transition-all focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2",
              onClick: ($event: any) => (handleImageSelect(image.url))
            }, [
              _createElementVNode("img", {
                src: image.url,
                alt: image.description || _ctx.defaultAlt,
                class: _normalizeClass(_ctx.imageClass),
                onError: handleImageError
              }, null, 42, _hoisted_5),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.overlayClass)
              }, null, 2)
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})